import React, { useEffect, useState } from "react";
import { TOP_BAR } from "../theme/appTheme";
import logo from "../../assets/brand/adaudit-logo.svg";

// Top bar (the AdAudit logo on the left; the account name and the
// menu button on the right) and the page area below it. The menu holds New
// search, Audits and Sign out.
// active: "newScan" | "jobs" - which menu item is highlighted.
// accountName: the signed-in account, so you always know which one you're in.
// fullHeight: the page fills exactly the window below the top bar, full
// width, and the window itself never scrolls (search page, report).
export default function AppShell({ fullHeight, active, accountName, onMyJobs, onNewScan, onSignOut, children }) {
  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif" }} className={fullHeight ? "h-screen flex flex-col overflow-hidden bg-violet-50/[0.15]" : "min-h-screen bg-violet-50/[0.15]"}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <div className={TOP_BAR.bar}>
        <div className={`${TOP_BAR.inner} ${fullHeight ? TOP_BAR.innerFull : TOP_BAR.innerCentred}`}>
          <img src={logo} alt="AdAudit" className={TOP_BAR.logo} />
          <div className={TOP_BAR.right}>
            {accountName && <span className={TOP_BAR.account} title={`Signed in to the ${accountName} account`}>{accountName}</span>}
            <MainMenu active={active} onNewScan={onNewScan} onMyJobs={onMyJobs} onSignOut={onSignOut} />
          </div>
        </div>
      </div>

      {fullHeight ? (
        <div className="flex-1 min-h-0">{children}</div>
      ) : (
        <div className="max-w-6xl mx-auto px-6 py-8">{children}</div>
      )}
    </div>
  );
}

// The purple menu button and its dropdown. Closes on a choice, a click
// outside it, or Escape.
function MainMenu({ active, onNewScan, onMyJobs, onSignOut }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const choose = action => () => { setOpen(false); action(); };
  const item = id => (active === id ? TOP_BAR.menuItemActive : TOP_BAR.menuItem);

  return (
    <div className="relative">
      <button
        type="button" onClick={() => setOpen(o => !o)} className={TOP_BAR.menuButton}
        aria-label="Menu" aria-haspopup="menu" aria-expanded={open}
      >
        <span className={TOP_BAR.menuIcon} aria-hidden="true">
          <span className={TOP_BAR.menuLine} /><span className={TOP_BAR.menuLine} /><span className={TOP_BAR.menuLine} />
        </span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-[1090]" onClick={() => setOpen(false)} />
          <div className={TOP_BAR.menuPanel} role="menu">
            <button type="button" role="menuitem" onClick={choose(onNewScan)} className={item("newScan")}>New search</button>
            <button type="button" role="menuitem" onClick={choose(onMyJobs)} className={item("jobs")}>Audits</button>
            <div className={TOP_BAR.menuDivider} />
            <button type="button" role="menuitem" onClick={choose(onSignOut)} className={TOP_BAR.menuItemMuted}>Sign out</button>
          </div>
        </>
      )}
    </div>
  );
}
